import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

export default function CheckoutForm({ onClose , amount}) {
  const stripe = useStripe();
  const elements = useElements();
 const [userData, setUserData] = useState({});
   useEffect(() => {
    const branchId = sessionStorage.getItem("branch_id");
    const companyId = sessionStorage.getItem("company_id");
    const userId = sessionStorage.getItem("user_id");
    const email = sessionStorage.getItem("email");
    const orderId=sessionStorage.getItem("order_id");

    setUserData({ branchId, companyId, userId, email ,orderId});
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    const card = elements.getElement(CardElement);
const amt=amount.toFixed(2);
const  branch_id=userData.branchId;
const   company_id=userData.companyId;
const   userId=userData.userId;
const email=userData.email;
const orderId=userData.orderId;


    const res = await fetch("http://103.235.105.54/admin/api/create-payment-intent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({userId:userId,email:email,amount: amt,orderId:orderId, branch_id:branch_id, company_id :company_id,currency: "INR", }), // ₹50.00
    });

    const { clientSecret } = await res.json();

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: { card },
    });

    if (result.error) {
      alert(result.error.message);
    } else if (result.paymentIntent.status === "succeeded") {
      alert("Payment Successful!");
      onClose(); // close modal
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2 className="text-lg font-bold mb-4">Stripe Checkout</h2>
      <CardElement className="p-2 border rounded" />
      <div className="flex justify-between mt-4">
        <button
          type="button"
          onClick={onClose}
        //   className="px-4 py-2 bg-gray-400 text-white rounded"
        className="btn col-lg-3 btn-danger"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={!stripe}
          className="btn col-lg-3 btn-success"
        //   className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Pay  ₹{amount.toFixed(2)}
        </button>
      </div>
    </form>
  );
}
